module.exports = __webpack_public_path__ + "img/top2.32af71c9.png";